import React from 'react';
import { ExpenseCategoriesPage } from './ExpenseCategoriesPage';
import { ExpenseCategoriesPageMobile } from './ExpenseCategoriesPageMobile';

const isMobile = () => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth <= 768;
};

const ExpensesCategoriesPageWrapper: React.FC = () => {
  const [mobile, setMobile] = React.useState(isMobile());

  React.useEffect(() => {
    const handleResize = () => {
      setMobile(isMobile());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return mobile ? <ExpenseCategoriesPageMobile /> : <ExpenseCategoriesPage />;
};

export default ExpensesCategoriesPageWrapper; 